import Base from '../Pages/Base'
import ListCategoriasProfessores from '../Pages/Categorias/List'
import FormCategoriasProfessores from '../Pages/Categorias/Form'
import ListProfessores from '../Pages/Professores/List'
import FormProfessores from '../Pages/Professores/Form'

export default [
	{
		path: 'servicos/professores-temporarios',
		component: Base,
		children: [
			{
				path: '',
				name: 'ListCategoriasProfessores',
				component: ListCategoriasProfessores,
				meta: {
					path: '/servicos/professores-temporarios',
					pai: 'Serviços',
					title: 'Admin - Professores Temporários',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Professores Temporários',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'novo',
				name: 'FormCategoriasProfessores',
				component: FormCategoriasProfessores,
				meta: {
					path: '/servicos/professores-temporarios',
					pai: 'Serviços',
					title: 'Admin - Professores Temporários - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Professores Temporários',
						class: '',
						active: false,
						url: '/servicos/professores-temporarios'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'editar/:id',
				name: 'FormCategoriasProfessoresEditar',
				component: FormCategoriasProfessores,
				meta: {
					path: '/servicos/professores-temporarios',
					pai: 'Serviços',
					title: 'Admin - Professores Temporários - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Professores Temporários',
						class: '',
						active: false,
						url: '/servicos/professores-temporarios'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: ':id',
				name: 'ListProfessores',
				component: ListProfessores,
				meta: {
					path: '/servicos/professores-temporarios',
					pai: 'Serviços',
					title: 'Admin - Professores Temporários - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Professores Temporários',
						class: '',
						active: false,
						url: '/servicos/professores-temporarios'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: false,
						newClass: 'menu-selecionado'
					}],
					noCache: true
				},
			},

			{
				path: ':id/novo',
				name: 'FormProfessoresN',
				component: FormProfessores,
				meta: {
					path: '/servicos/professores-temporarios',
					pai: 'Serviços',
					title: 'Admin - Professores Temporários - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Professores Temporários',
						class: '',
						active: false,
						url: '/servicos/professores-temporarios'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: ':id/editar/:cat',
				name: 'FormProfessoresEditar',
				component: FormProfessores,
				meta: {
					path: '/servicos/professores-temporarios',
					pai: 'Serviços',
					title: 'Admin - Professores Temporários - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Professores Temporários',
						class: '',
						active: false,
						url: '/servicos/professores-temporarios'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
		]
	}
]